__turbopack_context__.v({
  "splide__arrow": "sSOkTa_splide__arrow",
  "video_thumbnail_carousel": "sSOkTa_video_thumbnail_carousel",
});
